export default "__VITE_PUBLIC_ASSET__1afbd28c__"